import React from "react";
import SectionHeading from "../UI/SectionHeading";

const reviews = [
  {
    name: "Sophie R.",
    location: "Cherry Hinton",
    text: "Our fitted wardrobes are beautiful and practical. Everything was measured perfectly and the team left the room spotless each day.",
  },
  {
    name: "James C.",
    location: "Trumpington",
    text: "They built custom shelving and a window seat for our bay window. Great communication, sensible suggestions, and the finish is faultless.",
  },
  {
    name: "Emily J.",
    location: "Great Shelford",
    text: "We had a new deck and pergola installed and it’s transformed the garden. Reliable, tidy, and the workmanship is excellent.",
  },
];

function Stars() {
  return (
    <div className="flex gap-1 text-brass" aria-label="5 out of 5 stars">
      {[...Array(5)].map((_, i) => (
        <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 2l2.9 6.3 6.9.7-5.1 4.6 1.4 6.8L12 17.8 5.9 20.4l1.4-6.8L2.2 9l6.9-.7L12 2z" />
        </svg>
      ))}
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="bg-linen border-y border-hairline">
      <div className="max-w-site mx-auto px-5 sm:px-10 py-16 md:py-24">
        <SectionHeading
          eyebrow="Kind words"
          title="What our customers say"
          intro="A few words from homeowners across Cambridge and the surrounding villages."
          center
        />
        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {reviews.map((r) => (
            <figure key={r.name} className="bg-paper border border-hairline p-7 flex flex-col">
              <Stars />
              <blockquote className="text-ink leading-8 mt-5 flex-1 font-display text-lg">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-hairline">
                <span className="font-bold text-ink">{r.name}</span>
                <span className="block text-bark text-sm">{r.location}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
